module.exports = __webpack_public_path__ + "img/25.4c9d7871.png";